import moment from 'moment';
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'EcogyApp',
  data() {
    return {
      language: localStorage.getItem("locale") || "de"
    };
  },
  methods: {
    langchange() {
      localStorage.setItem("locale", this.language);
      this.$i18n.locale = this.language;
      moment.locale(this.language);
    },
    goToV2Portal() {
      const oneYear = 60 * 60 * 24 * 365;
      document.cookie = `ecogyPortalVersionV2=always;path=/;max-age=${oneYear}`;
      window.location.reload();
    }
  }
});